<script lang="ts" setup>
  import TrashIcon from '@/shared/components/icons/TrashIcon.vue'

  interface Props {
    dataTest?: string
  }

  interface Emits {
    (e: 'delete', status: boolean): void
  }

  const props = withDefaults(defineProps<Props>(), {
    dataTest: 'delete-modal',
  })

  const emit = defineEmits<Emits>()
</script>

<template>
  <div class="delete-modal" :data-test="dataTest">
    <div class="delete-modal__title">
      {{ $t('inbound_travelers_delete_header') }}
    </div>
    <div class="delete-modal__buttons">
      <button
        class="delete-modal__button"
        type="button"
        @click="emit('delete', false)"
        :data-test="`${props.dataTest}-cancel`"
      >
        {{ $t('inbound_travelers_delete_cancel_button') }}
      </button>
      <button
        class="delete-modal__button delete-modal__button_red"
        type="button"
        @click="emit('delete', true)"
        :data-test="`${props.dataTest}-accept`"
      >
        <TrashIcon class="delete-modal__icon delete-modal__icon_red" />
        <span> {{ $t('inbound_travelers_delete_accept_button') }} </span>
      </button>
    </div>
  </div>
</template>

<style lang="scss">
  @import '@/shared/assets/styles/colors';

  .delete-modal__icon {
    &_red {
      path {
        fill: $red;
      }
    }
  }
</style>

<style lang="scss" scoped>
  @import './DeleteModal';
</style>
